import React, { useState } from 'react';
import { FieldGroup, Modal, PillButton, Row, Select, Stack, TextArea } from 'library/ui';
import { client, consoleLogInDev } from 'shared';

const ReasonOptions = [
    'Worker arrived late',
    'Worker was not fully compliant',
    'Worker was not in dress code',
    'Other (please explain)',
];

export function SentHomeDisputeModal({
    small,
    isOpen,
    onClose,
    onSubmit,
    appointmentId,
    workerName,
}: {
    small: boolean;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    appointmentId?: number;
    workerName: string;
}) {
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');

    function onDisputeClick() {
        const details = comment ? `${reason}: ${comment}` : reason;
        client('api/disputes/', { body: { details, object_id: appointmentId, dispute_type: 'appointment' } })
            .then(() => {
                setReason('');
                setComment('');
                onSubmit();
            })
            .catch((error) => {
                consoleLogInDev(error);
            });
    }

    if (!isOpen) return null;

    return (
        <Modal
            title={`Why are you disputing that ${workerName} was sent home?`}
            subtitle="Please answer below"
            onClose={onClose}
            width={small ? 400 : 520}
        >
            <Stack gap="md">
                <FieldGroup label="Select a reason">
                    <Select
                        value={reason || ''}
                        options={ReasonOptions.map((b) => ({ key: b, value: b }))}
                        onChange={setReason}
                        fullWidth
                    />
                </FieldGroup>
                <FieldGroup label="Comments">
                    <TextArea value={comment} onChange={setComment} minRows={2} fullWidth />
                </FieldGroup>
                <Row justify="end">
                    <PillButton
                        onClick={onDisputeClick}
                        disabled={!reason || (reason === ReasonOptions[3] && !comment)}
                    >
                        Submit Dispute
                    </PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
